import { defaultPulseCheckApi } from '~src/services/ApiController';
import { AsyncAction } from '~src/services/apiMiddleware';
import { CycleI } from '~src/interfaces/cycle.interface';
import { getCycles, RESET_CYCLES } from '~src/shared/sidebar/constants/actionTypes';

export const fetchCycles = (): AsyncAction<CycleI[], undefined> => ({
  types: getCycles,
  callAPI: () => defaultPulseCheckApi.getCycles(),
});

export const resetCycles = () => ({ type: RESET_CYCLES });
